// Icons
import {
  HouseLine,
  Coin,
  Receipt,
  Globe,
  Envelope,
  Plus,
} from "phosphor-react";

// Panels
import Information from "../Panels/Static/Information";
import List from "../Panels/Collections/List";
import DonutChart from "../Panels/Graph/DonutChart";
import LineChart from "../Panels/Graph/LineChart";
import CallToAction from "../Panels/Static/CallToAction";

// Others
import React from "react";

const HomePage = () => {
  return (
    <main className="w-full pl-0.5 pr-1 noDesktop:[&>*]:w-[95%] noDesktop:flex noDesktop:flex-col noDesktop:items-end">
      <section className="flex">
        <HouseLine size={27.5} className="text-brand-500 mr-2" weight="bold" />
        <h1 className="text-xl">Dashboard</h1>
      </section>

      <section
        className={`w-full h-[calc(95%)] mt-3 grid grid-rows-5 grid-cols-4 gap-3 noDesktop:flex noDesktop:flex-col`}
      >
        {/* Row One */}
        <Information title={"Revenue"} Icon={Coin} />
        <Information title={"Expenses"} Icon={Receipt} />
        <Information title={"Net Income"} Icon={Globe} />

        <List title={"Upcoming Bills"} Icon={Plus} rowSpan={4} disabled />

        {/* Row Two */}
        <DonutChart title={"Revenue Categories"} Icon={Coin} rowSpan={2} />
        <LineChart title={"Revenue Timeline"} rowSpan={2} colSpan={2} />

        {/* Row Three */}
        <LineChart title={"Expenses Timeline"} rowSpan={2} colSpan={2} />
        <DonutChart title={"Expense Categories"} Icon={Receipt} rowSpan={2} />
        <CallToAction
          title={"Contact Us"}
          description={
            "We welcome any feedback, questions, or concerns you may have. Whether you are seeking assistance or looking to request a new feature, we are here to help. We look forward to hearing from you."
          }
          location={"mailto:mirelise.social@gmail.com"}
          Icon={Envelope}
        />
      </section>
    </main>
  );
};

export default HomePage;
